import { romeApi } from "./rome-api";
import store from "../../store";

const amfDebug = {
  invalidateApiToken() {
    store.state.session.apiToken = "test";
  },
  login: {
    init() {
      romeApi.api.interceptors.response.use(response => {
        try {
          rememberContactsAsSuggestedUsers(response);
          rememberBrokerAsSuggestedUser(response);
          rememberOprAsSuggestedUser(response);
        } catch (e) {
          console.log("exception", e);
        }
        return response;
      });
    },
    get suggestedUsers() {
      var users = [...this.contacts];
      users.push(this.broker);
      users = users.concat(this.oprs);
      return [...new Set(users)];
    },
    contacts: [],
    broker: null,
    oprs: [],
    addOpr(opr) {
      if (opr && opr.length) {
        var op = [];
        this.oprs = opr.map(o => o.email);
      } else {
        this.oprs = [];
      }
    },
    addBroker(broker) {
      this.broker = broker ? broker.email : null;
    },
    addContacts(contacts) {
      if (contacts && contacts.length) {
        this.contacts = contacts.map(c => c.email);
      } else {
        this.contacts = [];
      }
    }
  }
};

window.amfDebug = amfDebug;
export { amfDebug };

function rememberContactsAsSuggestedUsers(response) {
  if (isGetRequestFor(response, "contact") && response.data.contacts) {
    amfDebug.login.addContacts(response.data.contacts);
  }
}

function rememberBrokerAsSuggestedUser(response) {
  if (isGetRequestFor(response, "broker")) {
    amfDebug.login.addBroker(response.data);
  }
}
function rememberOprAsSuggestedUser(response) {
  if (isGetRequestFor(response, "opr")) {
    amfDebug.login.addOpr(response.data);
  }
}

function isGetRequestFor(response, type) {
  return (
    response &&
    response.config &&
    response.data &&
    response.config.method == "get" &&
    response.config.url &&
    response.config.url.endsWith(type)
  );
}



// WEBPACK FOOTER //
// ./src/framework/utils/amf-debug.js